var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 50,
    height: 50,
    rx: 10,
    fill: "#FCEACF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9987 32.2337C27.576 32.2337 29.6654 30.1444 29.6654 27.5671C29.6654 24.9897 27.576 22.9004 24.9987 22.9004C22.4214 22.9004 20.332 24.9897 20.332 27.5671C20.332 30.1444 22.4214 32.2337 24.9987 32.2337Z",
    stroke: "#F3A533",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2904 26.1074V27.1924C25.2904 27.6008 25.0804 27.9858 24.7187 28.1958L23.832 28.7324",
    stroke: "#F3A533",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3343 36.6667H29.6676C34.3576 36.6667 35.1976 34.7883 35.4426 32.5017L36.3176 23.1683C36.6326 20.3217 35.8159 18 30.8343 18H19.1676C14.1859 18 13.3693 20.3217 13.6843 23.1683L14.5593 32.5017C14.8043 34.7883 15.6443 36.6667 20.3343 36.6667Z",
    stroke: "#F3A533",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.332 18.0007V17.0673C20.332 15.0023 20.332 13.334 24.0654 13.334H25.932C29.6654 13.334 29.6654 15.0023 29.6654 17.0673V18.0007",
    stroke: "#F3A533",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2597 23.834C34.2414 25.304 32.0014 26.3307 29.6797 26.914",
    stroke: "#F3A533",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0586 24.1484C16.0069 25.4784 18.1303 26.4234 20.3353 26.9601",
    stroke: "#F3A533",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingBag);
export default __webpack_public_path__ + "static/media/working-bag.8aa356e71fda15f88f858a576ccd1f4a.svg";
export { ForwardRef as ReactComponent };